"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GameplayAvatar = exports.AVATAR_BUILD_PARAMS = void 0;
const tslib_1 = require("tslib");
const phaser_1 = tslib_1.__importDefault(require("phaser"));
const GameplayRenderer_1 = require("../GameplayRenderer");
const consts_1 = require("../consts");
// TODO: move to constants
exports.AVATAR_BUILD_PARAMS = {
    AVATAR_W: 843,
    AVATAR_H: 1200,
    FACE_X: 285,
    FACE_Y: 158,
    FACE_W: 240,
    FACE_H: 240,
    GIRL_FACE_Y: 340,
};
class GameplayAvatar extends phaser_1.default.GameObjects.Container {
    constructor(scene, side = consts_1.SIDE.CENTER) {
        super(scene);
        this.texturesToRemove = [];
        this.renderTexturesToRemove = [];
        this.isLoaded = false;
        this.loadingNum = 0;
        this.calculatedWidth = 0;
        this.calculatedHeight = 0;
        this.side = consts_1.SIDE.CENTER;
        this.side = side;
        this.imagesList = {};
    }
    destroy() {
        this.removeUnusedTextures();
        super.destroy();
    }
    setAvatarConfigAndResolver(avatarConfig, avatarResolver) {
        this.avatarComposition = avatarResolver.getComposition(avatarConfig);
        this.avatarResolver = avatarResolver;
        this.imagesList = {};
    }
    update(_time, _delta) {
        super.update(_time, _delta);
    }
    removeUnusedTextures() {
        for (const textureObj of this.texturesToRemove) {
            this.scene.releaseTextureByKey(textureObj.textureId);
            GameplayRenderer_1.GameplayRenderer.removeTexture(this.scene, textureObj.textureId, textureObj.url);
        }
        this.texturesToRemove = [];
    }
    removeUnusedRenderTextures(withoutLastOne = false) {
        const finalLength = this.renderTexturesToRemove.length;
        let lastItem = null;
        if (withoutLastOne) {
            lastItem = this.renderTexturesToRemove.pop();
        }
        for (let i = 0; i < finalLength; i++) {
            const renderTexture = this.renderTexturesToRemove[i];
            if (withoutLastOne && i === finalLength - 1) {
                continue;
            }
            renderTexture.destroy();
        }
        this.renderTexturesToRemove = [];
        if (lastItem) {
            this.renderTexturesToRemove.push(lastItem);
        }
    }
    updateBlendMode(sprite, blendMode) {
        switch (blendMode) {
            case 'multiply':
                sprite.setBlendMode(phaser_1.default.BlendModes.MULTIPLY);
                break;
            case 'source-atop':
                sprite.setBlendMode(phaser_1.default.BlendModes.SOURCE_ATOP);
                break;
            default:
                sprite.setBlendMode(phaser_1.default.BlendModes.NORMAL);
                break;
        }
    }
    destroyCreatedImages(images) {
        for (const image of images) {
            image.destroy();
        }
    }
    drawAvatarOnTexture() {
        if (!this.avatarComposition || !this.imagesList) {
            return;
        }
        this.avatarRenderTexture = new phaser_1.default.GameObjects.RenderTexture(this.scene, 0, 0, exports.AVATAR_BUILD_PARAMS.AVATAR_W, exports.AVATAR_BUILD_PARAMS.AVATAR_H);
        const bodyContainer = new phaser_1.default.GameObjects.Container(this.scene);
        const headContainer = new phaser_1.default.GameObjects.Container(this.scene);
        const headIndex = this.avatarComposition.findIndex(compItem => compItem.name === 'head');
        const compositionLength = this.avatarComposition.length;
        const isHead = (headIndex > -1);
        if (isHead) {
            const headComposition = this.avatarComposition[headIndex];
            this.avatarHeadRenderTexture = new phaser_1.default.GameObjects.RenderTexture(this.scene, 0, 0, headComposition.rect[2], headComposition.rect[3]);
        }
        const imagesToDestroy = [];
        // for(const compositionItem of this.avatarComposition) {
        for (let i = 0; i < compositionLength; i++) {
            const compositionItem = this.avatarComposition[i];
            if (!this.imagesList[compositionItem.name]) {
                continue;
            }
            const itemTexture = this.imagesList[compositionItem.name].textureId;
            const itemUrl = this.imagesList[compositionItem.name].url;
            const [x, y, width, height] = compositionItem.rect;
            this.calculatedWidth = Math.max(width, this.calculatedWidth);
            this.calculatedHeight = Math.max(height, this.calculatedHeight);
            const image = new phaser_1.default.GameObjects.Image(this.scene, x, y, itemTexture);
            image.setOrigin(0, 0);
            this.updateBlendMode(image, compositionItem.blend);
            // this.avatarRenderTexture.batchDraw(image);
            // image.destroy();
            if (i < headIndex || !isHead) {
                bodyContainer.add(image);
            }
            else {
                headContainer.add(image);
            }
            imagesToDestroy.push(image);
            this.texturesToRemove.push({ textureId: itemTexture, url: itemUrl });
        }
        if (isHead && this.avatarHeadRenderTexture) {
            this.avatarHeadRenderTexture.beginDraw();
            this.avatarRenderTexture.batchDraw(headContainer);
            this.avatarHeadRenderTexture.endDraw();
        }
        this.avatarRenderTexture.beginDraw();
        this.avatarRenderTexture.batchDraw(bodyContainer);
        // this.avatarRenderTexture.batchDraw(headContainer);
        if (this.avatarHeadRenderTexture) {
            this.avatarRenderTexture.batchDraw(this.avatarHeadRenderTexture);
            this.avatarHeadRenderTexture.destroy();
            this.avatarHeadRenderTexture = undefined;
        }
        this.avatarRenderTexture.endDraw();
        this.calculatedWidth = Math.min(exports.AVATAR_BUILD_PARAMS.AVATAR_W, this.calculatedWidth);
        this.calculatedHeight = Math.min(exports.AVATAR_BUILD_PARAMS.AVATAR_H, this.calculatedHeight);
        this.avatarRenderTexture.x = -this.calculatedWidth / 2; // -AVATAR_BUILD_PARAMS.AVATAR_W / 2;
        this.avatarRenderTexture.y = -this.calculatedHeight; // -AVATAR_BUILD_PARAMS.AVATAR_H;
        this.destroyCreatedImages(imagesToDestroy);
        bodyContainer.destroy();
        headContainer.destroy();
        this.add(this.avatarRenderTexture);
        this.removeUnusedRenderTextures();
        this.removeUnusedTextures();
        this.renderTexturesToRemove.push(this.avatarRenderTexture);
    }
    loadAllAvatarImages(currentLoadingNum) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (!this.avatarComposition || !this.avatarResolver) {
                return;
            }
            const imagesPromiseList = [];
            const composition = this.avatarComposition;
            for (let i = 0; i < composition.length; i++) {
                const compositionItem = composition[i];
                const { src, name } = compositionItem;
                if (!src || src === "") {
                    continue;
                }
                const imgSrc = this.avatarResolver.getImageURL(src).toString();
                imagesPromiseList.push(this.loadSingleAvatarImage(imgSrc, name));
            }
            yield Promise.all(imagesPromiseList);
            return {
                loadingNum: currentLoadingNum
            };
        });
    }
    loadSingleAvatarImage(imageUrl, imageName) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { isLoading, textureId } = GameplayRenderer_1.GameplayRenderer.getImageId(imageUrl, this.scene);
            this.imagesList[imageName] = { textureId, url: imageUrl };
            if (!isLoading) {
                return Promise.resolve(textureId);
            }
            return new Promise((resolve) => {
                GameplayRenderer_1.GameplayRenderer.imageLoadedHook(textureId, this.scene, (tId) => {
                    resolve(tId);
                });
            });
        });
    }
    getScaleDir() {
        switch (this.side) {
            case consts_1.SIDE.LEFT:
                return 1;
            case consts_1.SIDE.RIGHT:
            default:
                return -1;
        }
    }
    static preloadByAvatarConfig(config, scene, avatarResolver) {
        const composition = avatarResolver.getComposition(config);
        for (const { src } of composition) {
            const imageUrl = avatarResolver.getImageURL(src).toString();
            GameplayRenderer_1.GameplayRenderer.getImageId(imageUrl, scene);
        }
    }
}
exports.GameplayAvatar = GameplayAvatar;
